import React, { useEffect, useRef, useState } from "react";

function Main({
  children
}) {
  const mainContainerRef = useRef(null);

  return (
    <main>
      <div className=" mt-2">
        <div className={"w-full overflow-x-hidden px-6"}>{children}</div>
      </div>
    </main>
  );
}

export default Main;
